export default "__VITE_ASSET__D$wEj7B0__"